import { render } from "./ListeBlacklistPage.vue?vue&type=template&id=60657b48&ts=true"
import script from "./ListeBlacklistPage.vue?vue&type=script&lang=ts"
export * from "./ListeBlacklistPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__